/** A shared empty-string instance so that we don't have to keep allocating them in memory. */
export const EMPTY_STRING = "";
